import { render, staticRenderFns } from "./meal-ideas.vue?vue&type=template&id=1eebf801"
import script from "./meal-ideas.vue?vue&type=script&lang=js"
export * from "./meal-ideas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./meal-ideas.vue?vue&type=custom&index=0&blockType=router"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PatternsEditoNavigation: require('/home/node/app/components/patterns/edito-navigation/edito-navigation.vue').default,PatternsEditoMedia: require('/home/node/app/components/patterns/edito-media/edito-media.vue').default,PatternsEditoPush: require('/home/node/app/components/patterns/edito-push/edito-push.vue').default,PatternsEditoHeader: require('/home/node/app/components/patterns/edito-header/edito-header.vue').default,PatternsMediaBlock: require('/home/node/app/components/patterns/media-block/media-block.vue').default,PatternsBannerApp: require('/home/node/app/components/patterns/banner-app/banner-app.vue').default,PatternsServiceList: require('/home/node/app/components/patterns/service-list/service-list.vue').default,ElementsEditoFootnotes: require('/home/node/app/components/elements/edito-footnotes/edito-footnotes.vue').default})
